import { render, staticRenderFns } from "./CategoriesNote.vue?vue&type=template&id=d7d8a04e&"
import script from "./CategoriesNote.vue?vue&type=script&lang=js&"
export * from "./CategoriesNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports